import { render, staticRenderFns } from "./ProjectSummaryStretchGoal.vue?vue&type=template&id=310a1fb0&"
import script from "./ProjectSummaryStretchGoal.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryStretchGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports